export const ERROR_MESSAGES = {
  phoneNumber: 'Please enter a valid phone number',
  email: 'Please enter a valid email address',
  name: 'Please enter your name',
}
